import queryString from 'querystring';

import { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';

import { useSelector } from 'react-redux';

import { Navigator } from './Navigator';

import de from '../../locales/de.json';
import en from '../../locales/en.json';
import fr from '../../locales/fr.json';
import it from '../../locales/it.json';
import { searchString } from '../../store/location/selectors';
import { storeLocale } from '../../store/ui/selectors';
import { flattenMessages } from '../../utils';

import Modals from './shared/base/modals/modals';

const App = () => {
    const [lang, setLang] = useState<string>(useSelector(storeLocale));
    const sourceMessages = { de: de, en: en, it: it, fr: fr };
    const search = useSelector(searchString);
    const parsedSearch = queryString.parse(search.replace('?', ''));

    useEffect(() => {
        if (parsedSearch.lang) {
            setLang(parsedSearch.lang as string);
        }
    }, [parsedSearch.lang]);

    return (
        <>
            <IntlProvider locale={lang} defaultLocale={'de'} messages={{ ...flattenMessages(sourceMessages[lang]) }}>
                <Modals />
                <Navigator />
            </IntlProvider>
        </>
    );
};

export default App;
